import * as React from "react";

interface ProgressBubbleProps {
  section: string;
  type?: string;
}

const ProgressBubble: React.FC<ProgressBubbleProps> = ({ section, type }) => {
  const typeClass = (type || "Edit").toLowerCase().replace(/\s+/g, "-");
  return (
    <div className="progress-chat-bubble">
      <div className="progress-chat-icon">
        <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="3">
          <path d="M50 16H30a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h24a6 6 0 0 0 6-6V26l-10-10z" />
          <polyline points="50 16 50 26 60 26" />
          <line x1="34" y1="38" x2="50" y2="38" />
          <line x1="34" y1="48" x2="50" y2="48" />
        </svg>
      </div>
      <div className="progress-chat-content">
        <span className="progress-chat-section">{section}</span>
        <span className={`progress-chat-type ${typeClass}`}>{type || "Edit"}</span>
      </div>
    </div>
  );
};

export default ProgressBubble;
